import { render } from "./colab-details.vue?vue&type=template&id=67e8b8d2"
import script from "./colab-details.vue?vue&type=script&lang=js"
export * from "./colab-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__